var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"385ae5cfc01b5dce5e6f18d115a6cd6b28a53d55"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-login@docupet"]={id:"385ae5cfc01b5dce5e6f18d115a6cd6b28a53d55"};
      